// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__UD1Px","content":"Consent_content__LfINq","footer":"Consent_footer__3UnQi"};